import { render, staticRenderFns } from "./ProjectQuota.vue?vue&type=template&id=a8cd68ee&scoped=true&"
import script from "./ProjectQuota.vue?vue&type=script&lang=ts&"
export * from "./ProjectQuota.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectQuota.vue?vue&type=style&index=0&id=a8cd68ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cd68ee",
  null
  
)

export default component.exports